import type { PriceLevelInfo } from "./BottomUpDailyGrid";

interface Props {
  // Price levels used by at least one visible day.
  levels: PriceLevelInfo[];
}

// Read-only key for the colored day bands in the By Day header.
export default function PricingLegend({ levels }: Props) {
  if (levels.length === 0) return null;
  return (
    <div
      style={{ background: "var(--background)", borderColor: "var(--border)" }}
      className="inline-flex items-center gap-3 border rounded-full pl-3 pr-2.5 py-1"
    >
      <span
        style={{ color: "var(--muted-foreground)" }}
        className="text-[10px] font-semibold uppercase tracking-wider"
      >
        Pricing
      </span>
      {levels.map((pl) => (
        <span
          key={pl.id}
          className="inline-flex items-center gap-1.5 text-[11px]"
          style={{ color: "var(--foreground)" }}
        >
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: 2,
              background: pl.color || "var(--muted)",
              boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.08)",
            }}
          />
          {pl.name}
        </span>
      ))}
    </div>
  );
}
